<template>
  <q-dialog
    :visible="isVisible"
    :title="title"
    width="800px"
    :innerScroll="false"
    :loading="loadingButtom"
    @close="onCancel"
    @cancel="onCancel"
    @confirm="onConfirm"
  >
    <div class="tips">编辑说明：编辑内容非实时生效，当月编辑后，生效时间为次月1号开始；</div>
    <el-form :model="addForm" ref="addForm" :rules="rules" size="small" label-width="120px">
      <el-form-item label="修片类型：">
        <span>{{ addForm.retouchType }}</span>
      </el-form-item>
      <el-form-item label="折算后数量：" prop="estimate">
        <span style="margin-right: 10px">张</span><el-input v-model="addForm.estimate"></el-input>
      </el-form-item>
    </el-form>
  </q-dialog>
</template>

<script>
import axios from '@/utils/axiosInstance';
export default {
  props: {
    // 重新对外暴露visible，控制显示隐藏
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: Object,
  },
  data() {
    return {
      addForm: {
        retouchType: '',
        estimate: '',
      },
      userId: '',
      userList: [],
      userList1: [],
      all: false,
      rules: {
        estimate: [
          { required: true, message: '不能为空', trigger: 'blur' },
          { pattern: /^(?:1000(?:\.0{1,2})?|1000\.0{1,2}|[1-9]\d{0,2}(?:\.\d{1,2})?|0(?:\.\d{1,2})?)$/, message: '请输入0-1000内的数字(最多2位小数)' },
        ],
      },
      loading: false,
      loadingButtom: false,
    };
  },
  computed: {
    // 通过计算属性，对.sync进行转换，外部也可以直接使用visible.sync
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
    title() {
      return '编辑';
    },
  },
  mounted() {
    Object.assign(this.addForm, this.rowData);
    // this.addForm.userIdMain = addForm.userIdMain + '';
    // this.addForm.userIdDeputy = addForm.userIdDeputy ? addForm.userIdDeputy + '' : '';
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },
    onConfirm() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) return;
        this.loadingButtom = true;
        this.$q.newProduct
          .updateWorkloadCalculate({ data: this.addForm })
          .then((res) => {
            if (res.code == 200) {
              let text = this.title + '成功';
              this.$message.success(text);
              this.isVisible = false;
              this.$emit('success');
            }
          })
          .finally((_) => {
            this.loadingButtom = false;
          });
      });
    },
  },
};
</script>

<style lang="stylus" scoped>

.tips {
  color: red
  padding-left: 38px
  margin-bottom: 20px
}

 >>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 200px !important;
}
</style>
